module.exports = __webpack_public_path__ + "assets/images/premium-features/projected-sales-edits-88c437.png";